import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsAndConditions = () => {
    const { t } = useTranslation();

    return (
        <div className="terms-and-conditions">
            <h1>{t('terms_and_conditions.title')}</h1>
            <p>{t('terms_and_conditions.welcome_message')}</p>

            <h1>{t('terms_and_conditions.section_1.title')}</h1>
            <p>{t('terms_and_conditions.section_1.content')}</p>

            <h1>{t('terms_and_conditions.section_2.title')}</h1>
            <p>{t('terms_and_conditions.section_2.content')}</p>

            <h1>{t('terms_and_conditions.section_3.title')}</h1>
            <p>{t('terms_and_conditions.section_3.content')}</p>
            <ul>
                {t('terms_and_conditions.section_3.restrictions', { returnObjects: true }).map((restriction, index) => (
                    <li key={index}>{restriction}</li>
                ))}
            </ul>

            <h1>{t('terms_and_conditions.section_4.title')}</h1>
            <p>{t('terms_and_conditions.section_4.content')}</p>

            <h1>{t('terms_and_conditions.section_5.title')}</h1>
            <p>{t('terms_and_conditions.section_5.content')}</p>

            <h1>{t('terms_and_conditions.section_6.title')}</h1>
            <p>{t('terms_and_conditions.section_6.content')}</p>

            <h1>{t('terms_and_conditions.section_7.title')}</h1>
            <p>{t('terms_and_conditions.section_7.content')}</p>

            <h1>{t('terms_and_conditions.section_8.title')}</h1>
            <p>{t('terms_and_conditions.section_8.content')}</p>

            <h1>{t('terms_and_conditions.section_9.title')}</h1>
            <p>{t('terms_and_conditions.section_9.content')}</p>

            <h1>{t('terms_and_conditions.section_10.title')}</h1>
            <p>{t('terms_and_conditions.section_10.content')}</p>

            <h1>{t('terms_and_conditions.section_11.title')}</h1>
            <p>{t('terms_and_conditions.section_11.content')}</p>

            <h1>{t('terms_and_conditions.last_section.title')}</h1>
            <p>{t('terms_and_conditions.last_section.content')}</p>
        </div>
    );
};

export default TermsAndConditions;
